// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loader_loading__sR7G1","onboardingLoading":"Loader_onboardingLoading__Ct5vU"};